<template>
  <v-dialog v-model="dialog" max-width="1000" style="max-height: 100%" v-resize="onResize">
    <v-card v-if="isReady" class="standard-row font-theme"
      style="border: 1px solid #000000; border-radius: 20px; padding: 5px 1px 14px 20px;">
      <div class="scroll-theme add-vendor-detail-scroll">
        <v-form lazy-validation ref="headerForm">
          <p style="font-size: 32px; font-weight: 700;" class="mb-0">
            GL Account
          </p>

          <v-row no-gutters class="standard-row mb-7">
            <v-col v-for="(item, index) in detailVendor.Detail" :key="item.key" cols="12" sm="6" md="6" lg="6"
              class="mt-3 mt-md-1" style="font-size: 14px;">
              <v-row no-gutters class="standard-row">
                <v-col cols="12" sm="12" md="5" style="font-weight: 700;" class="pr-sm-3">
                  {{ item.label }}
                </v-col>

                  <v-col v-if="item.key === 'material_name'" cols="12" sm="12" md="7" class="pr-sm-3">
                  <v-autocomplete :items="materialData" v-model="selectedMaterial" return-object
                    item-text="material_name" outlined dense hide-details class="dropdown-select-gl"
                    append-icon="mdi-chevron-down" color="black" :loading="loadingMaterial" :rules="textRules" required>
                    <template v-slot:item="data">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="font-theme" style="font-size: 12px; line-height: 20px;">{{
                          data.item.material_name}}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title class="font-theme"
                            style="line-height: 20px;">ไม่พบข้อมูล</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col v-else-if="item.key === 'material_code'" cols="12" sm="12" md="7" class="pr-sm-3">
                  <v-text-field hide-details outlined height="25" v-model="dataInputs.material_code" type="text"
                    color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required readonly />
                </v-col>
                <!-- Type of Vendor -->
                <v-col v-else-if="item.key === 'type_of_vendor'" cols="12" sm="12" md="7" class="pr-sm-3">
                  <v-autocomplete v-model="dataInputs.type_of_vendor" :items="typeOfVendorList" item-text="type"
                    item-value="type" multiple outlined dense hide-details class="dropdown-select-gl"
                    append-icon="mdi-chevron-down" color="black"  :rules="textRulesMultiple" required >
                  </v-autocomplete>
                </v-col>

                <!-- Cost Center -->
                <v-col v-else-if="item.key === 'cost_center'" cols="12" sm="12" md="7" class="pr-sm-3">
                  <v-autocomplete v-model="dataInputs.cost_center" :items="costCenterList" item-text="cost_center_type"
                    item-value="cost_center_type" multiple outlined dense hide-details class="dropdown-select-gl"
                    append-icon="mdi-chevron-down" color="black" :rules="textRulesMultiple" required >
                  </v-autocomplete>
                </v-col>
                <!-- Default Text -->
                <v-col v-else cols="12" sm="12" md="7" class="pr-sm-3">
                  <v-text-field hide-details outlined height="25" v-model="dataInputs[item.key]" type="text"
                    color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules"
                    required />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="standard-row d-flex justify-end">
            <v-btn rounded @click="closeDialog" color="red" class="elevation-0 font-theme white--text mr-2"
              style="width: 100px; height: 35px;">
              ยกเลิก
            </v-btn>
            <v-btn rounded @click="submitForm" color="#0B68D6" class="elevation-0 font-theme white--text"
              style="width: 100px; height: 35px;">
              ยืนยัน
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </v-card>

    <addExcelModal />
  </v-dialog>
</template>

<script>
import { EventBus } from '../EventBus'
import addExcelModal from '../components/addExcelModal.vue'
import {  materialList } from '@/functions/materialService.js'
export default {
  components: { addExcelModal },

  data() {
    return {
      dialog: false,
      isReady: false,
      textRules: [v => !!v],
      selectedMaterial: null,
      loadingMaterial: false,
      materialData:[],
      textRulesMultiple: [
        v => Array.isArray(v) && v.length > 0 || 'กรุณาเลือก Cost Center'
      ],
      dataInputs: {
        material_code: '',
        material_name: '',
        cost_center: [], // ['D','E']
        gl_code_new: '',
        gl_account_name_new: '',
        type_of_vendor: []
      },

      detailVendor: {
        Detail: [
          { key: 'material_name', label: 'Material name' },
          { key: 'material_code', label: 'Material code' },
          { key: 'cost_center', label: 'Cost Center' },
          { key: 'gl_code_new', label: 'GL code new' },
          { key: 'gl_account_name_new', label: 'GL account name new' },
          { key: 'type_of_vendor', label: 'Type of Vendor' }
        ]
      },
      windowSize: { x: 0 },

      costCenterList: [
        { cost_center_type: 'D' },
        { cost_center_type: 'E' },
        { cost_center_type: 'B' },
        { cost_center_type: 'S' },
        { cost_center_type: 'M' }
      ],

      typeOfVendorList: [
        { type: 'Other' },
        { type: 'ย่อย' },
        { type: 'ร่วม-ร่วมค้า-ผู้ถือหุ้น' }
      ]
    }
  },

  watch: {
    dialog(val) {
      if (!val) {
        this.dataInputs = {
          material_code: '',
          material_name: '',
          cost_center: [],
          gl_code_new: '',
          gl_account_name_new: '',
          type_of_vendor: []
        }
        this.selectedMaterial = null
      }
    },
    selectedMaterial(val) {
      console.log(val)
    if (!val) {
      this.dataInputs.material_name = ''
      this.dataInputs.material_code = ''
      return
    }

    this.dataInputs.material_name = val.material_name
    this.dataInputs.material_code = val.material_code
  }
  },

  mounted() {
    EventBus.$on('openAddGLAccountDetail', this.openDialog)
    EventBus.$on('offDialog', this.closeDialog)
  },

  beforeDestroy() {
    EventBus.$off('openAddGLAccountDetail')
    EventBus.$off('offDialog')
  },

  methods: {
    openDialog() {
      this.isReady = false
      this.$nextTick(() => {
        this.materialData = materialList
        this.dialog = true
        this.isReady = true
      })
    },

    closeDialog() {
      this.dialog = false
    },

    async submitForm() {
      if (!this.$refs.headerForm.validate()) return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info')
      const payload = {
        material_code: this.dataInputs.material_code,
        material_name: this.dataInputs.material_name,
        cost_center: this.dataInputs.cost_center.map(cc => ({
          cost_center_type: cc
        })),
        gl_code_new: this.dataInputs.gl_code_new,
        gl_account_name_new: this.dataInputs.gl_account_name_new,
        type_of_vendor: this.dataInputs.type_of_vendor.map(e => ({
          type: e
        }))
      }

      try {
        const { data } = await this.axios.post(
          `${this.$api_url}/gl_account/api/v1/add_gl_account`,
          payload
        )

        if (data.status) {
          this.alert('เพิ่มข้อมูลสำเร็จ', 'Success', 'success')
          this.dialog = false
        } else {
          this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
        }
      } catch (e) {
        this.alert('เพิ่มข้อมูลไม่สำเร็จ', 'Fail', 'error')
        console.error(e)
      }
    },

    onResize() {
      this.windowSize.x = window.innerWidth
    },

    alert(title = '', text = 'Fail', icon = 'info') {
      this.$swal({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: `<b class="alert-success-title">${title}</b>`,
        text: text,
        showClass: {
          popup: 'animate-show-card'
        },
        customClass: {
          container: 'alert-card-block',
          popup: 'alert-card-success',
          title: 'alert-title-block',
          htmlContainer: 'alert-text-box',
          icon: 'alert-icon'
        }
      })
    }
  }
}
</script>

<style>
.add-vendor-detail-scroll {
  padding-right: 10px;
  color: black;
  overflow-y: auto;
  border-radius: 0px !important;
  max-height: calc(100vh - 158px);
}

.dropdown-select-gl.v-text-field {
  height: 25px;
  max-height: 25px;
}

.dropdown-select-gl .v-input__control,
.dropdown-select-gl .v-input__slot,
.dropdown-select-gl .v-select__selections {
  min-height: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  padding-left: 8px;
}

.dropdown-select-gl input {
  line-height: 25px;
  height: 25px;
  padding: 8px 0px !important;
  margin: 0px 10px !important;
  padding-left: 8px;
}

.dropdown-select-gl .v-select__selections {
  padding-left: 12px !important;
  /* ปรับได้ 8–14px */
}

.dropdown-select-gl .v-input__append-inner {
  height: 25px;
  margin-top: 0 !important;
  display: flex;
  align-items: center;
}


.dropdown-select-gl .v-icon {
  font-size: 18px;
}

@media only screen and (max-width: 600px) {
  .add-vendor-detail-scroll {
    max-height: calc(100vh - 238px) !important;
  }
}
</style>